import { z } from "zod"

export const BiMetricResponseDataSchema = z.object({
  date: z.string(),
  type: z.enum(["Count", "Money", "Rate"]),
  category: z.string(),
  field: z.string(),
  value: z.string().nullable(),
  count: z
    .bigint()
    .nullable()
    .transform((val) => (val === null ? null : Number(val))),
  amount: z
    .any()
    .nullable()
    .transform((val) => (val === null ? null : Number(val))),
})

export const BiMetricsResponseDataSchema = z.array(BiMetricResponseDataSchema)
